import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { getCamerasBySiteAlerts } from "./AlertsUtils/getCamerasBySiteAlerts";
import { alertsFilterMultiSelectSx } from "./AlertsUtils/alertsFilterBar";

export const SiteDropDownAlertsPage = ({
  userFilters,
  setUserFilters,
  siteOptions,
  setCameraOptions,
  setCameraDropDownValue,
  navigate,
  siteDropDownValue,
  setSiteDropDownValue,
  loadingSites,
  setLoadingCameras,
}: {
  userFilters: any;
  setUserFilters: Dispatcher<any>;
  siteOptions: any;
  setCameraOptions: Dispatcher<any>;
  setCameraDropDownValue: Dispatcher<string[]>;
  navigate: NavigateFunction;
  siteDropDownValue: string[];
  setSiteDropDownValue: Dispatcher<string[]>;
  loadingSites: boolean;
  setLoadingCameras: Dispatcher<boolean>;
  navBarCollapsed: boolean;
}) => {
  const siteNamesMap = new Map();
  siteOptions.forEach((object: any) => {
    siteNamesMap.set(object.id, object.name);
  });

  const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");

  const parentIdsMap = new Map();
  parentAccounts.forEach((object: any) => {
    parentIdsMap.set(object.name, object.id);
  });

  // Convert siteDropDownValue strings to objects for the Autocomplete.
  // Memoized so the array keeps its identity across unrelated re-renders:
  // MUI treats a new `value` reference as a selection change and clears
  // the typed search text (SUP-868).
  const selectedSiteObjects = React.useMemo(
    () =>
      siteDropDownValue.map((siteName: string) => ({
        id: siteOptions.find((object: any) => object.name === siteName)?.id,
        name: siteName,
      })),
    [siteDropDownValue, siteOptions]
  );

  return (
    <div className="w-full">
      <Autocomplete
        multiple
        size="small"
        limitTags={1}
        sx={alertsFilterMultiSelectSx}
        value={selectedSiteObjects}
        disablePortal
        options={
          siteOptions[0]
            ? siteOptions.map((object: any, index: number) => ({
              id: object.id,
              name: object.name,
              index: index,
            }))
            : []
        }
        getOptionLabel={(option) => option.name || ""}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        loading={loadingSites}
        onChange={(event, value: any[]) => {
          if (value && value.length > 0) {
            const siteIdsArray: string[] = [];
            const siteValuesArray: string[] = [];
            value.forEach((siteObject: any) => {
              siteIdsArray.push(siteObject.id);
              siteValuesArray.push(siteObject.name);
            });
            setSiteDropDownValue(siteValuesArray);
            localStorage.setItem(
              "siteDropDownValue",
              JSON.stringify(siteValuesArray)
            );
            setCameraDropDownValue([]);
            localStorage.setItem("cameraDropDownValue", JSON.stringify([]));
            getCamerasBySiteAlerts(
              siteIdsArray,
              navigate,
              setCameraOptions,
              setLoadingCameras
            );
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                site: siteIdsArray,
                camera: "",
              };
            });
          } else {
            setSiteDropDownValue([]);
            setCameraDropDownValue([]);
            setCameraOptions([]);
            setUserFilters((previousState: any) => {
              return {
                ...previousState,
                site: [],
                camera: [],
              };
            });
            setLoadingCameras(false);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label="Site"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingSites ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
          />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    </div>
  );
};
